import { render, staticRenderFns } from "./VideoBackgroundEditor.vue?vue&type=template&id=0d2077be&scoped=true"
import script from "./VideoBackgroundEditor.vue?vue&type=script&lang=js"
export * from "./VideoBackgroundEditor.vue?vue&type=script&lang=js"
import style0 from "./VideoBackgroundEditor.vue?vue&type=style&index=0&id=0d2077be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2077be",
  null
  
)

export default component.exports